import type { PassoProduto } from "@/api"
import { capitalize } from "@/lib/formato"
import { textoFracao, type EtapaPasso, type SelecaoPasso } from "../passos"

export type PassoStatus = 'ativo' | 'concluido' | 'pendente' | 'bloqueado'

export function passoObrigatorio(passo: PassoProduto): boolean {
    return passo.quantidadeMinima > 0
}

export function textoRegraPasso(passo: PassoProduto): string {
    const { quantidadeMinima: min, quantidadeMaxima: max } = passo

    if (min === 0) return max === 1 ? 'Opcional' : `Opcional · até ${max}`
    if (min === max) return `Escolha ${min}`

    return `Escolha de ${min} a ${max}`
}

/** Número de cada etapa como o cliente conta: só os passos; a de adicionais fica com o número do passo pai. */
export function numerosDasEtapas(etapas: EtapaPasso[]): number[] {
    let numero = 0

    return etapas.map((etapa) => (etapa.pai ? numero : (numero += 1)))
}

/** "Sabores" num passo; "Adicionais na ½ Calabresa" nos adicionais de uma opção dele. */
export function tituloDaEtapa({ passo, pai }: EtapaPasso, numero: number): string {
    const nome = capitalize(passo.tabelaPreco?.descricao ?? (pai ? 'Adicionais' : `Passo ${numero}`))
    if (!pai) return nome

    const fracao = textoFracao(pai.fracao)

    return `${nome} na ${fracao ? `${fracao} ` : ''}${capitalize(pai.nome)}`
}

/** Linha sob o título da etapa ativa: nos adicionais de uma parte da pizza, onde vai e quanto do preço custa. */
export function apoioDaEtapa({ passo, pai }: EtapaPasso): string {
    if (!pai || pai.fracao >= 1) return textoRegraPasso(passo)

    const sabor = capitalize(pai.nome)
    const ate = passo.quantidadeMaxima > 1 ? ` · até ${passo.quantidadeMaxima}` : ''

    if (Math.abs(pai.fracao - 0.5) < 1e-9) return `Só na metade ${sabor} · metade do preço${ate}`

    return `Só na parte ${sabor} · ${textoFracao(pai.fracao)} do preço${ate}`
}

/** "Bacon saiu junto com Quatro Queijos"; com vários, "Bacon e Milho saíram junto com Quatro Queijos". */
export function avisoAdicionaisRemovidos(adicionais: string[], sabor: string): string {
    const lista = new Intl.ListFormat('pt-BR', { type: 'conjunction' }).format(adicionais.map(capitalize))

    return `${lista} ${adicionais.length === 1 ? 'saiu' : 'saíram'} junto com ${capitalize(sabor)}`
}

export function itensSelecionadosTexto(passo: PassoProduto, selecao: SelecaoPasso): string {
    return (passo.tabelaPreco?.itens ?? [])
        .filter((it) => (selecao[it.id] ?? 0) > 0)
        .map((it) => {
            const quantidade = selecao[it.id] ?? 0

            return quantidade > 1 ? `${it.nomeProduto} ×${quantidade}` : it.nomeProduto
        })
        .join(', ')
}